module.exports = __webpack_public_path__ + "img/pay-result-header.3e3a102.png";